module.exports = __webpack_public_path__ + "static/media/photoDefault.c9717ece.svg";